(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-detail-tabs]').forEach(group => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      const tabs = [...group.querySelectorAll('[role="tab"]')];
      const activate = tab => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); activate(tabs[next]); tabs[next].focus();
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind()); else bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
